import { Component, OnDestroy, OnInit } from '@angular/core';
import { BroadcastService } from '@azure/msal-angular';
import { TranslateService } from '@ngx-translate/core';
import { NotificationStatus, NotificationViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { NotificationDispatcherService } from '@services/cleanfill-core/store-notifications/notification-dispatcher.service';
import { StoreNotificationService } from '@services/cleanfill-core/store-notifications/store-notification.service';
import { ExpiredTokenHandler } from '@services/core/expired-token-handler';
import { SimpleNotificationViewModel } from '@view-models/notifications/simple-notification';
import { ProgressBarComponent } from '@widgets/ui-common/components/progress-bar/progress-bar.component';
import { IconsService } from '@widgets/ui-common/icons/icons.service';
import { Spinkit } from 'ng-http-loader';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public spinkit = Spinkit;
  ProgressBarComponent = ProgressBarComponent;
  title = 'CleanFillFe';
  subscription = new Subscription();
  constructor(
    private icons: IconsService,
    private broadcastService: BroadcastService,
    private expiredTokenHandler: ExpiredTokenHandler,
    private notificationService: StoreNotificationService,
    private notificationDispatcher: NotificationDispatcherService,
    private translateService: TranslateService
  ) {
    icons.loadIcons();
    this.expiredTokenHandler.initialize();
    translateService.setDefaultLang('en');
  }

  ngOnInit() {
    this.subscription.add(
      this.notificationDispatcher.notifications$.subscribe((t: SimpleNotificationViewModel) => {
        const notification = new NotificationViewModel();
        notification.body = t.body;
        notification.createdBy = '';
        notification.createdDate = t.createdDate;
        notification.status = NotificationStatus.New;
        this.notificationService.addNotifications([notification]);
      })
    );

    this.notificationDispatcher.ngOnInit();
  }

  ngOnDestroy() {
    this.notificationDispatcher.ngOnDestroy();
    this.broadcastService.getMSALSubject().next(1);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.expiredTokenHandler.release();
  }
}
